import { useState, useCallback } from "react";
import { PerfilesPuesto } from "../api";
import { useAuth } from "./useAuth";

const api = new PerfilesPuesto();

export function useExtractPDF() {
  const { accessToken } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const extract = useCallback(
    async (file) => {
      setLoading(true);
      setError(null);
      setResult(null);
      try {
        const response = await api.extraerPDF(accessToken, file);
        setResult(response.data);
        return response.data;
      } catch (err) {
        const msg = err?.message || "Error al procesar el PDF";
        setError(msg);
        throw new Error(msg);
      } finally {
        setLoading(false);
      }
    },
    [accessToken]
  );

  const reset = useCallback(() => {
    setResult(null);
    setError(null);
    setLoading(false);
  }, []);

  return { loading, error, result, extract, reset };
}
